import { EventHeader } from "widgets";
import { Footer } from "widgets";
import { RecordCheckQR } from "features/check-record-by-qr";
import styles from "./RecordCheckPage.module.scss";

export const RecordCheckPage = () => {
  return (
    <div className={styles.pageContainer}>
      <div className={styles.pageWrapper}>
        <div className={styles.pageWrapper__header}>
          <EventHeader />
        </div>
        <RecordCheckQR />
      </div>
      <Footer />
    </div>
  );
};
